<template>
  <div class="earnings-calls-info-skeleton">
    <div class="earnings-calls-info-skeleton-list">
      <div class="earnings-calls-info-skeleton-item">
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
      </div>
      <div class="earnings-calls-info-skeleton-item">
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
      </div>
      <div class="earnings-calls-info-skeleton-item">
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
      </div>
      <div class="earnings-calls-info-skeleton-item">
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
        <span class="earnings-calls-info-skeleton-loader-paragraph" />
      </div>
    </div>
  </div>
</template>
